// Short notification beep generated with WebAudio (no audio file needed, works
// on laptop + mobile). Used by Live Chat for incoming messages / chat requests.
let ctx = null;

const getCtx = () => {
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  if (!ctx) ctx = new AC();
  if (ctx.state === 'suspended') ctx.resume();
  return ctx;
};

const tone = (at, freq, duration, gainValue) => {
  const c = getCtx();
  if (!c) return;
  const osc = c.createOscillator();
  const gain = c.createGain();
  osc.type = 'sine';
  osc.frequency.value = freq;
  gain.gain.setValueAtTime(0, at);
  gain.gain.linearRampToValueAtTime(gainValue, at + 0.02);
  gain.gain.exponentialRampToValueAtTime(0.0001, at + duration);
  osc.connect(gain);
  gain.connect(c.destination);
  osc.start(at);
  osc.stop(at + duration + 0.02);
};

// Two quick beeps — a new message arrived.
export const beepMessage = () => {
  const c = getCtx();
  if (!c) return;
  const t = c.currentTime;
  tone(t, 880, 0.14, 0.25);
  tone(t + 0.18, 1175, 0.16, 0.25);
};

// Longer ring — someone is asking you to join a live chat.
export const beepRing = () => {
  const c = getCtx();
  if (!c) return;
  const t = c.currentTime;
  for (let i = 0; i < 4; i++) {
    tone(t + i * 0.42, 988, 0.18, 0.3);
    tone(t + i * 0.42 + 0.2, 1319, 0.18, 0.3);
  }
};

// Vibrate too (phones), harmless where unsupported.
export const buzz = (pattern = [120, 60, 120]) => {
  try { if (navigator.vibrate) navigator.vibrate(pattern); } catch (e) { /* ignore */ }
};
